import contenteditableTypes from '../constants/contenteditable-types';
import getMatchedContenteditableType from '../helpers/get-matched-contenteditable-type';

const canBeRichEdited = (node) => {
  const contenteditableType = getMatchedContenteditableType(node);
  return contenteditableType === contenteditableTypes.RICH;
};

export default canBeRichEdited;
